import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incident-bild';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentBildEffects {

    IncidentBild$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENT_BILD),
        mergeMap((x: ac.GetIncidentBildAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentBild(x.incident_id, x.bild_id).pipe(
                map((result: any) => {
                    return new ac.GetIncidentBildErfolgreichAction(result, x.incident_id, x.bild_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentBildFehlerAction(error, x.incident_id, x.bild_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsQueryService);
        }
        return this.service;
    }
}
